import { Injectable } from '@angular/core';
import { ErrorHandlerService } from '@y42/error-handling';
import { combineLatest, map, Observable, shareReplay } from 'rxjs';
import type { ExportSettingsGitModel } from '../export';
import { ExportTypeContentfulService } from './export-type-contentful.service';
import { ExportTypeModel } from './export-type.model';

@Injectable({ providedIn: 'root' })
export class ExportTypeQuery {
  constructor(
    private readonly exportCTypeService: ExportTypeContentfulService,
    private readonly errorHandlerService: ErrorHandlerService,
  ) {}

  readonly exportTypes$: Observable<ExportTypeModel[]> = combineLatest([
    this.exportCTypeService.select((st) => st.entityState),
  ]).pipe(
    map(([cTypes]) => (cTypes || []).map((t) => t as ExportTypeModel)),
    shareReplay({ bufferSize: 1, refCount: true }),
  );

  findModelBySchema(
    schema: ExportSettingsGitModel['$schema'],
    options?: { skipUnsupportedSchemaErrorLog: boolean },
  ): ExportTypeModel | undefined {
    const types: ExportTypeModel[] = this.exportCTypeService.getData() || [];
    const exportTypeRegex = /.*\/exports\/(.*)\/[0-9.]+\/(source|table)/;
    // 0: "https://s.y42.com/exports/csv/0.0.1/source"
    // 1: "csv"
    // 2: "source"
    const regExpMatch = exportTypeRegex.exec(schema);
    const result = types.find(({ type }) => regExpMatch?.includes(type));
    if (!result && !options?.skipUnsupportedSchemaErrorLog) {
      this.errorHandlerService.error('[ExportTypeQuery.findModelBySchema]: Unknown schema type.', {
        context: { schema, knownTypes: types },
      });
    }
    return result;
  }
}
